import { setIn, get, getIn } from 'utils/immutable'
import { fromJS } from 'immutable'

import * as actions from 'actions/feature/affinityGroups'

export default {
  [actions.TOGGLE_AFFINITY_HIGHLIGHT]: toggleAffinityHighlight,
  [actions.resetAffinityHighlights]: resetAffinityHighlights,
}

function toggleAffinityHighlight(state, { queryUri }) {
  // queryUri belongs to the query that rungs on other
  // query-sets reference as their inputs
  const group = getIn(['affinityGroups', queryUri])(state)

  if (group === undefined) {
    const groups = get('affinityGroups', state)
    const groupNumber = groups.size
    const newGroup = {
      groupNumber,
      on: true,
    }

    return setIn(['affinityGroups', queryUri], newGroup)(state)
  }

  const notOn = !get('on', group)
  return setIn(['affinityGroups', queryUri, 'on'], notOn)(state)
}

function resetAffinityHighlights(state) {
  return state.set('affinityGroups', fromJS({}))
}
